// Store blob URLs so we can clean them up later
const blobUrls: Record<string, string> = {};

// Create a blob URL from a file's content
export const createBlobUrl = (name: string): string => {
    // Check if we've already created a blob URL for this file
    if (blobUrls[name]) {
        return blobUrls[name];
    }

    try {
        // For all files, try to load them from the public directory first
        // This assumes the files have been copied to the consuming project's public directory
        const publicUrl = `/${name}`;

        // For WASM files, always use direct public URL
        if (name.endsWith(".wasm")) {
            blobUrls[name] = publicUrl;
            return publicUrl;
        }

        // For other files, also use direct public URL since they're copied there
        // This avoids the blob URL creation complexity and potential issues
        blobUrls[name] = publicUrl;
        return publicUrl;

    } catch (err) {
        console.error(`Error creating URL for ${name}:`, err);
        throw new Error(`Could not import asset: ${name}`);
    }
};

// Clean up all blob URLs (though we're now using direct URLs, keeping for compatibility)
export const cleanupBlobUrls = (): void => {
    Object.values(blobUrls).forEach((url) => {
        // Don't try to revoke URLs that aren't blob URLs
        if (url.startsWith("blob:")) {
            try {
                URL.revokeObjectURL(url);
            } catch (err) {
                console.error(`Error revoking blob URL: ${url}`, err);
            }
        }
    });
    // Clear the stored URLs
    Object.keys(blobUrls).forEach(key => delete blobUrls[key]);
};